const initial = {
   settingsPayload: {}
}

export default function (state = initial, action) {
   switch (action.type) {

      case 'GET_SETTINGS':
         {
            return {
               ...state,
               settingsPayload: action.payload
            };
         }
      default:
         return state;
   }
}
